import { createInterception } from "../utils/interceptor";
import { addSwiperScript } from "../utils/load-script";
import { isWhitelisted } from "../utils/whiteListSlider";

export const createSlider = (container) => {
  const PAGE_ONE = 1;
  const { progress, slidesMobile, slides, pagination, navigation, auto, speed, spacing, spacingMobile } =
    container.dataset;

  let swiperParams = {
    slidesPerView: Number(slidesMobile),
    spaceBetween: Number(spacingMobile),
    a11y: false,
    loop: auto === 'true',
    ...(speed > 0 && {
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
    }),
    ...(Number(progress) > 0 && {
      speed: progress,
      freeMode: true,
    }),
    breakpoints: {
      640: {
        slidesPerView:
          Number(slides) === PAGE_ONE
            ? Number(slides)
            : Number(slidesMobile) + 1,
      },
      967: {
        slidesPerView: Number(slides),
        spaceBetween: Number(spacing)
      },
    },
  };

  if (navigation === 'true') {
    swiperParams = loadNavigation(container, swiperParams);
  }

  if (pagination === 'true') {
    swiperParams = loadPagination(container, swiperParams);
  }

  Object.assign(container, swiperParams);
  
  try {
    container.initialize();
  } catch(e){
    console.error("createSlider: ", e, container);
  }
};

const loadPagination = (slider, params) => {
  const parent = slider.parentNode;
  const paginationContainer = parent.querySelector('.swiper-pagination');
  if (!paginationContainer || !params) return;

  const mutationParams = Object.assign({}, params);

  mutationParams['pagination'] = {
    el: paginationContainer,
    clickable: true,
  };

  return mutationParams;
};

const loadNavigation = (slider, params) => {

  const parent = slider.parentNode;
  if (parent.querySelectorAll('.swiper-button').length < 2 || !params) return;
  const mutationParams = Object.assign({}, params);

  const buttonNext = parent.querySelector('.swiper-button-next', parent);
  const buttonPrev = parent.querySelector('.swiper-button-prev', parent);

  mutationParams['navigation'] = {
    nextEl: buttonNext,
    prevEl: buttonPrev,
  };

  return mutationParams;
};

/**
A function that loads sliders on a page by
creating an intersection observer for each slider container element.
@returns {void}
*/
export const prepareSliders = () => {
  const dataSliders = document.querySelectorAll('.slider-js');

  let loadingScript = false;

  dataSliders.forEach((slider) => {
    if(isWhitelisted(slider)){
      createSlider(slider);
    } else { 
        return createSlider(slider);
    }
    
  });
};
